// src/elements/Validation/constants.ts
var VALIDATION_ICON_MAP = {
  success: "check",
  warning: "exclamation",
  info: "info",
  error: "exclamation-circle",
  dim: "info"
};
export { VALIDATION_ICON_MAP };